import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Authentification\QRCodeController::__invoke
* @see app/Http/Controllers/Authentification/QRCodeController.php
* @route '/api/login/qrcode/generate'
*/
const QRCodeController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: QRCodeController.url(options),
    method: 'post',
})

QRCodeController.definition = {
    methods: ["post"],
    url: '/api/login/qrcode/generate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Authentification\QRCodeController::__invoke
* @see app/Http/Controllers/Authentification/QRCodeController.php
* @route '/api/login/qrcode/generate'
*/
QRCodeController.url = (options?: RouteQueryOptions) => {
    return QRCodeController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Authentification\QRCodeController::__invoke
* @see app/Http/Controllers/Authentification/QRCodeController.php
* @route '/api/login/qrcode/generate'
*/
QRCodeController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: QRCodeController.url(options),
    method: 'post',
})

export default QRCodeController